const encodedTextPrefix = '__imlog_text_b64url__:'

const encodeBase64Url = (value) => {
  const bytes = new TextEncoder().encode(value)
  let binary = ''
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte)
  })
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

const encodeTextField = (value) => {
  if (typeof value !== 'string' || value.startsWith(encodedTextPrefix)) return value
  return `${encodedTextPrefix}${encodeBase64Url(value)}`
}

export const encodeIMLogTextFields = (imLog) => {
  if (!imLog) return imLog
  return {
    ...imLog,
    title: encodeTextField(imLog.title),
    description: encodeTextField(imLog.description),
  }
}
